// import { AdminCheckOperationReportComponent } from "../../../components/SupportSystem/OperationReportForm/AdminCheckOperationReportComponent";
import { MoveSupportIdComponent } from "../../../components/SupportSystem/MoveSupportId/MoveSupportIdComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function MoveSupportIdContainer() {
    const titleName = "ย้ายหน่วยงานสำหรับคำขอรับเงินช่วยเหลือหรืออุดหนุน";
    return (
        <div className="page-container bg-landing">
            {/* <NavbarSupportSystem /> */}
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <MoveSupportIdComponent />
            <Footer />
        </div>
    )
}